import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { notification, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const SocialCallback = () => {
    const { provider } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const userJson = params.get('user');
        const mfaEnabled = params.get('mfa_enabled');
        const mfaToken = params.get('mfa_token');
        const mfaType = params.get('mfa_type');
        const error = params.get('error');

        if (error) {
            notification.error({
                message: 'Login Failed',
                description: decodeURIComponent(error),
            });
            navigate('/login', { replace: true });
            return;
        }

        if (mfaEnabled === 'true') {
            navigate('/multi-factor-authentication', {
                replace: true,
                state: {
                    mfa_token: mfaToken,
                    mfa_type: mfaType,
                },
            });
            return;
        }

        if (token && userJson) {
            try {
                const user = JSON.parse(userJson);
                notification.success({
                    message: 'Login Successful',
                    description: 'Welcome back!',
                });

                localStorage.setItem('user_id', user.id);
                localStorage.setItem('first_name', user.first_name);
                localStorage.setItem('last_name', user.last_name);

                navigate('/dashboard', { replace: true });
            } catch (e) {
                console.error('Failed to parse user data', e);
                notification.error({
                    message: 'Login Error',
                    description: 'An error occurred during social login processing.',
                });
                navigate('/login', { replace: true });
            }
        } else {
            notification.error({
                message: 'Login Error',
                description: 'Invalid response from server.',
            });
            navigate('/login', { replace: true });
        }
    }, [location, navigate, provider]);

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f0f2f5'
        }}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#AD1457' }} spin />} />
            <div style={{ marginTop: 24, fontSize: 18, color: '#64748B', fontWeight: 500 }}>
                Authenticating with {provider ? provider.charAt(0).toUpperCase() + provider.slice(1) : 'Provider'}...
            </div>
        </div>
    );
};

export default SocialCallback;
